import { AxiosRequestConfig } from "axios";
import moment from "moment";
import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { IoPagination } from "../../../../helper/pagination";
import { customerService } from "../../customer/service/customer.service";
import { promotionService } from "../../promotion/service/promotion.service";
import { User } from "../../user/entity/user.model";
import { userService } from "../../user/service/user.service";
import { Plan, PlanFilter, PlanType, PlanUI } from "../entity/plan.model";

async function getPlans(planFilter: PlanFilter): Promise<IoPagination<PlanUI>> {
  if (planFilter.startDate === undefined || planFilter.startDate.length === 0) {
    delete planFilter.startDate;
  }

  if (planFilter.endDate === undefined || planFilter.endDate.length === 0) {
    delete planFilter.endDate;
  }

  let plans: IoPagination<PlanUI> = await api.get("/mt/plans", {
    params: planFilter,
  });

  plans.content.forEach((plan) => {
    plan.startDate = moment(plan.startDate);
    plan.endDate = moment(plan.endDate);
  });

  return plans;
}

async function getPlan(uuid: string): Promise<PlanUI> {
  let plan: Plan = await api.get(`/mt/plans/${uuid}`);
  let users: User[] = await userService.getUsers(plan.username);

  let returningPlan: PlanUI = {
    ...plan,
    startDate: moment(plan.startDate),
    endDate: moment(plan.endDate),
    month: moment(plan.startDate).month() + 1,
    user: users.at(0),
  };

  if (plan.planType === PlanType.PROMOTION && plan.promotionId) {
    returningPlan.promotion = await promotionService.getPromotion(
      plan.promotionId
    );
  } else if (plan.planType === PlanType.CUSTOMER && plan.customerId) {
    returningPlan.customer = await customerService.getCustomer(plan.customerId);
    returningPlan.customer.label = returningPlan.customer.name;
    returningPlan.customer.value = returningPlan.customer.uuid;
  }

  return returningPlan;
}

function deletePlan(uuid: string) {
  return api.delete(`/mt/plans/${uuid}`);
}

function updatePlan(plan: PlanUI): Promise<void> {
  let _plan: Plan = convertPlanUI(plan);
  return api.put(`/mt/plans/${plan.planType?.toLowerCase()}`, _plan);
}

function addPlan(plan: PlanUI): Promise<PlanUI> {
  let _plan: Plan = convertPlanUI(plan);
  return api.post(`/mt/plans/${plan.planType?.toLowerCase()}`, _plan);
}

function convertPlanUI(plan: PlanUI): Plan {
  let _plan = {
    ...plan,
    username: plan.user?.username!,
    startDate: plan.startDate?.format(mConstants.DATE_FORMAT)!,
    endDate: plan.endDate?.format(mConstants.DATE_FORMAT)!,
    promotionId: plan.promotion?.uuid,
  };
  delete _plan.user;
  return _plan;
}

function uploadCustomerPlan(file: File, routeId: string): Promise<any> {
  const formData = new FormData();
  formData.append("file", file);

  const config: AxiosRequestConfig = {
    headers: {
      "content-type": "multipart/form-data",
    },
    params: {
      routeId,
    },
  };

  return api.post(`/mt/plans/customer/import`, formData, config);
}

export const planService = {
  getPlans,
  getPlan,
  deletePlan,
  updatePlan,
  addPlan,
  uploadCustomerPlan,
};
